import { render, staticRenderFns } from "./BoxedLogin.vue?vue&type=template&id=a0dc15ac"
import script from "./BoxedLogin.vue?vue&type=script&lang=js"
export * from "./BoxedLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports